/* eslint-disable no-undef */
export const baseUrl = `${window.location.protocol}//${window.location.host}/`;
export const apiUrl = process.env.REACT_APP_API_URL || '/api';
export const mlApiUrl = process.env.REACT_APP_ML_FORECASTING_API_URL;
export const authToken = process.env.REACT_APP_AUTH_TOKEN;
export const googleSsoClientID = process.env.REACT_APP_GOOGLE_SSO_CLIENT_ID;
export const chargebeeSiteUrl = process.env.REACT_APP_CHARGEBEE_SITE;
export const chargebeeApiKey = process.env.REACT_APP_CHARGEBEE_API_KEY;
export const WebPushCertificateKey =
  'BLU0dlxeZ4JNeQBfiUiyg6mGtkuS64ic6WHKN8cfMHy5DtwSDf06SCCECYWjY4CukvCZ8T43JytaolSAk5E6Ywg';

const getEnvFromHostname = () => {
  const { hostname } = window.location;
  if (/sellergeni.com$/.test(hostname)) {
    if (/^app.stage/.test(hostname)) return 'staging';
    return 'production';
  }
  return 'development';
};

export const env = getEnvFromHostname();
